import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext({ user: null, login: async () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = unauth, obj = authed
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let mounted = true;
        api.get("/auth/me")
            .then((r) => mounted && setUser(r.data))
            .catch(() => mounted && setUser(false))
            .finally(() => mounted && setReady(true));
        return () => {
            mounted = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data?.token) localStorage.setItem("teneria_token", data.token);
        setUser({ id: data.id, email: data.email, nombre: data.nombre, rol: data.rol });
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (_) {}
        localStorage.removeItem("teneria_token");
        setUser(false);
    };

    return <AuthCtx.Provider value={{ user, login, logout, ready }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
